import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { changeMastersInitialStateRegions, handlePaginationStateRegions } from "../../../store/masters/mastersSlice";

const mapStateToProps = (state) => {
    return {
        // regions
        formType: state.masters.formTypeRegions,
        initialValues: state.masters.initialValuesRegions,
        showDrawer: state.masters.showDrawerRegions,
        pagination: state.masters.paginationRegions,
    };
};

const mapDispatch = {
    changeRegionsInitialState: changeMastersInitialStateRegions,
    handlePaginationState: handlePaginationStateRegions,
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(mapDispatch, dispatch);

const Store = (Container) =>
    connect(mapStateToProps, mapDispatchToProps)(Container);

export default Store;